//Appointments modules
import styles from "../../styles/appointments/AppointmentsCron.module.css"

//PrimeReact
import { RadioButton } from "primereact/radiobutton"
import { Dropdown } from "primereact/dropdown"
import { getNumberRange, weekDays } from "./utils"

export default function AppointmentsFormCronMonth({
  monthlyType,
  monthlyNDays,
  monthlyNMonths,
  monthlyNthDay,
  monthlyWeekDay,
  onSetMonthlyType,
  onSetMonthlyNDays,
  onSetMonthlyNMonths,
  onSetMonthlyNthDay,
  onSetMonthlyWeekDay,
}) {
  const nthDayOptions = [
    { name: "First", value: 1 },
    { name: "Second", value: 2 },
    { name: "Third", value: 3 },
    { name: "Forth", value: 4 },
  ]

  const checkMonthlyType = (type) => {
    if (monthlyType !== type) {
      onSetMonthlyType(type)
    }
  }

  return (
    <>
      <div>Monthly options: </div>
      <div className={styles.cronOption}>
        <RadioButton
          value={"nDay_nMonth"}
          onChange={(e) => {
            onSetMonthlyType(e.value)
          }}
          checked={monthlyType === "nDay_nMonth"}
          className={styles.cronOptionRadioButton}
        />
        <span className={styles.cronOptionPortion}>Day </span>
        <Dropdown
          options={getNumberRange(1, 31)}
          value={monthlyNDays}
          onChange={(e) => {
            onSetMonthlyNDays(e.value)
            checkMonthlyType("nDay_nMonth")
          }}
          className={`${styles.cronOptionPortion} ${styles.numberOptionDropDown}`}
        />

        <span className={styles.cronOptionPortion}> of every </span>
        <Dropdown
          options={getNumberRange(1, 12)}
          value={monthlyNMonths}
          onChange={(e) => {
            onSetMonthlyNMonths(e.value)
            checkMonthlyType("nDay_nMonth")
          }}
          className={`${styles.cronOptionPortion} ${styles.numberOptionDropDown}`}
        />
        <span className={styles.cronOptionPortion}> month(s)</span>
      </div>
      <div className={styles.cronOption}>
        <RadioButton
          value={"weekDays"}
          onChange={(e) => {
            onSetMonthlyType(e.value)
          }}
          checked={monthlyType === "weekDays"}
          className={styles.cronOptionRadioButton}
        />
        <span className={styles.cronOptionPortion}>The </span>
        <Dropdown
          options={nthDayOptions}
          optionLabel="name"
          value={monthlyNthDay}
          onChange={(e) => {
            onSetMonthlyNthDay(e.value)
            checkMonthlyType("weekDays")
          }}
          className={`${styles.cronOptionPortion} ${styles.nDayOfWeekOptionDropDown}`}
        />
        <Dropdown
          options={weekDays}
          optionLabel="name"
          value={monthlyWeekDay}
          onChange={(e) => {
            onSetMonthlyWeekDay(e.value)
            checkMonthlyType("weekDays")
          }}
          className={`${styles.cronOptionPortion} ${styles.dayOfWeekOptionDropDown}`}
        />
        <span className={styles.cronOptionPortion}> of every </span>{" "}
        <Dropdown
          options={getNumberRange(1, 12)}
          value={monthlyNMonths}
          onChange={(e) => {
            onSetMonthlyNMonths(e.value)
            checkMonthlyType("weekDays")
          }}
          className={`${styles.cronOptionPortion} ${styles.numberOptionDropDown}`}
        />
        <span className={styles.cronOptionPortion}> month(s)</span>
      </div>
    </>
  )
}
